// extracted by mini-css-extract-plugin
export default {"eventContainer":"NoEvents_eventContainer__Q4IdI","link":"NoEvents_link__mUyD-"};